export default {"src":"/_next/static/media/arrowLeftWhite.c10b521d.svg","height":19,"width":12,"blurWidth":0,"blurHeight":0};